<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()
const waitRetryTime = 1000 * 10
const disableRetryButton = ref(true)

// todo 遷移先確認
const resetApp = () => {
  router.replace({ name: 'Login', query: { initialize_app: 'reset' } })
}
setTimeout(() => {
  disableRetryButton.value = false
}, waitRetryTime)
</script>

<template>
  <div class="initializeAppError">
    <div class="initializeAppError__icon">
      <v-icon
        icon="fa-gear"
        class="initializeAppError__icon-gear"
      />
      <div class="initializeAppError__icon-xmark">
        <v-icon icon="fa-xmark" />
      </div>
    </div>
    <div class="initializeAppError__body">
      <h2 class="initializeAppError__title">
        アプリの初期設定に異常が発生しました
      </h2>
      <p class="initializeAppError__message">
        アプリの初期設定に異常が発生したため、処理の中断を行いました。
        10秒後に「ホームへ」ボタンが有効になりますので、やり直しをお願いいたします。
      </p>
      <button
        type="button"
        :disabled="disableRetryButton"
        class="initializeAppError__button c-button c-button--border c-button--border c-button--medium"
        @click="resetApp"
      >
        ホームへ
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.initializeAppError{
  &__icon{
    height: 200px;
    width: 200px;
    position: relative;
    background: var(--frameColor);
    border-radius: 100%;
    margin: 0 auto 30px;
    box-shadow: 0 0 1px rgb(0 0 0 / 50%), 0 0 3px rgb(0 0 0 / 20%);
  }

  &__icon-gear{
    height: 100px;
    width: 100px;
    display: block;
    margin: auto;
    position: absolute;
    inset: 0;
  }

  &__icon-xmark{
    background: #FFF;
    height: 30px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    border: 2px solid #dd2121;
    position: absolute;
    bottom: 42px;
    right: 54px;

    &::v-deep(svg){
      width: 28px;
      height: 18px;
      color: #dd2121;
    }
  }

  &__title{
    color: #dd2121;
    margin: 20px;
    text-align: center;
    font-size: 1.6rem;
  }

  &__button{
    margin-top: 30px;
  }
}
</style>
